import getCollection from './getCollection'
import getObject from './getObject'
import updateDataById from 'actions/base/updateDataById'

const updateSlot = (id, slot) => updateDataById(id, getCollection, getObject(slot))

export default updateSlot
